<div class="app-sign-field-viewer relative">
  <ng-container *ngFor="let signer of signers">
    <ng-container *ngFor="let signField of signFields | filterSignFieldsBySigner: signer">
      <lib-document-field
        *ngIf="signField.topLeft && signField.bottomRight"
        class="app-doc-page-canvas-sign-field"
        [class.z1]="signer.personalId === activeSigner?.personalId"
        [class.z2]="signField.id === activeSignField?.id"
        [boundingBox]="
          { topLeft: signField.topLeft, bottomRight: signField.bottomRight } | boundingBox
        "
      >
        <app-editable-sign-field
          [signField]="signField"
          [signer]="signer"
          [color]="signer.personalId === activeSigner?.personalId ? 'accent' : null"
          [active]="signField.id === activeSignField?.id"
          (clickContent)="clickSignField.emit(signField)"
          (deleteSignField)="deleteSignField.emit(signField)"
          (changeSignFieldType)="changeSignFieldType.emit($event)"
          (finishSignFieldEdit)="finishSignFieldEdit.emit(signField)"
        ></app-editable-sign-field>
      </lib-document-field>
    </ng-container>
  </ng-container>
</div>
